import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "7",
  cy: "7",
  r: "6.5",
  stroke: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.57 5.243a1.5 1.5 0 0 1 2.91.435c0 .74-.572 1.17-.99 1.443-.29.209-.49.414-.49.629V8",
  stroke: "currentColor",
  "stroke-width": "1.1",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "7",
  cy: "10",
  r: ".6",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }